<template>
<v-dialog id="signout" :value="openDialog" persistent>
  <v-card color="rgba(0, 0, 0, 0.9)" class="border-radius-15 modal-class">
    <v-container pa-0 text-xs-center>
      <div class="py-3">
        <v-icon size="75" color="white">account_circle</v-icon>
      </div>
      <v-card-text class="question-text-container">

        <p class="text-xs-center white--text fs-24">Are you sure you want to logout?</p>

      </v-card-text>
      <v-flex xs12>
        <v-alert class="subheader text-uppercase" my-0 py-0 v-show="error" value="error" type="error">
          {{ error }}
        </v-alert>
        <div id="error-spacer" v-show="!error">

        </div>
      </v-flex>
      <v-container>
        <v-layout column align-center>

          <v-flex>
            <div class="action-buttons ma-3" @click="signOut">
              <img :src="YesButton" height="100%"/>
            </div>
              <div class="action-buttons ma-3" @click="takeMeBack">
                <img :src="NoButton" height="100%"/>
            </div>
          </v-flex>
        </v-layout>
      </v-container>

    </v-container>
  </v-card>

</v-dialog>
</template>

<script>
import { Auth, Logger, JS, Cache } from "aws-amplify";
import YesButton from "../../../assets/logout/yes-icon.png";
import NoButton from "../../../assets/logout/no-icon.png";
const logger = new Logger("SignOutComp");

caches.open("v1").then(function(cache) {
  var init = {
    status: 200,
    statusText: "SuperSmashingGreat!"
  };
  var myResponse = new Response(
    "YEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAa",
    init
  );
  cache.put("joeblow.com", myResponse);
});
export default {
  name: "SignOut",
  data() {
    return {
      error: "",
      NoButton,
      YesButton,
      openDialog: true
    };
  },
  methods: {
    signOut: function(event) {
      Auth.signOut()
        .then(() => {
          logger.debug("sign out success");
          this.$store.dispatch("clearAmplifyCache");
          this.$store.dispatch("clearMainCache");
          this.$store.dispatch("clearTourCache");
          this.$router.push("/auth/signIn");
        })
        .catch(err => this.setError(err));
    },
    takeMeBack: function(event) {
      this.openDialog = false;
      this.$router.go(-1);
    },
    setError: function(err) {
      this.error = err.message || err;
    }
  }
};
</script>

<style>
.modal-text-box {
  height: 75%;
}

.v-alert .v-alert__icon.v-icon {
  color: rgba(0, 0, 0, 0.54);
}

.action-buttons {
  width: 50%;
  height: 50px;
}
</style>
